import { render, staticRenderFns } from "./company-representative-form.vue?vue&type=template&id=8236df00&"
import script from "./company-representative-form.vue?vue&type=script&lang=js&"
export * from "./company-representative-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports